<template>
	<div class="comp">
		<el-dialog :title="'检测报告'" :visible.sync="dialogState" @close="close" width="1200px" top="5vh">
			<div v-if="!$public.isNull(detail.inspectItem.filter(d=>{return d.isPay===true}))">
				<div v-for="(item,index) in detail.inspectItem" :key="index">
					<div v-if="item.isPay===true" class="itemBox">
						<div style="line-height: 26px;">项目：</div>
						<div >
							<div class="goodsBox">
								{{item.goodsName}}
								<el-button v-if="detail.completeState===1" type="primary" size="mini" @click="upload(item)">上传</el-button>
							</div>
							<div v-for="(img,imgIndex) in item.fileArr" :key="imgIndex" class="imgBox">
								<span style="cursor: pointer;margin-right: 10px;" @click="openWindiw(img)">{{img}}</span>
								<el-button v-if="detail.completeState===1" type="danger" size="mini" @click="del(item,imgIndex)">删除</el-button>
							</div>
						</div>
						<!-- <img style="width:100%;" :src="item.filePath"> -->
					</div>
				</div>
			</div>
			<div v-else>
				<div style="text-align: center;line-height: 200px;font-size: 16;font-weight: bold;">
					没有已支付的检测项目
				</div>
			</div>
			<!-- <div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit">立 即 打 印</el-button>
			</div> -->
		</el-dialog>
		<input type="file" style="width:0;height: 0;" ref="dialogBingliCheckedFile" @change="changeFile"/>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:false,
				detail:{
					inspectItem:[],
				},
				
				curRow:{},
			}
		},
		props:{
			bingliObj:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.dialogState = true
			})
			this.detail = JSON.parse(JSON.stringify(this.bingliObj))
			for(let i=0;i<this.detail.inspectItem.length;i++){
				if(this.$public.isNull(this.detail.inspectItem[i].filePath)){
					this.detail.inspectItem[i].filePath = ''
					this.$set(this.detail.inspectItem[i],'fileArr',[])
				}else{
					this.$set(this.detail.inspectItem[i],'fileArr',this.detail.inspectItem[i].filePath.split(','))
				}
			}
		},
		methods: {
			close(){
				this.$emit('submit',{type:'close',data:''})
			},
			submit(){
				this.$emit('submit',{type:'success',data:''})
			},
			openWindiw(url){
				window.open(url);
			},
			del(row,imgIndex){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.curRow = row
					this.curRow.fileArr.splice(imgIndex,1)
					this.$http.post('/api/Case/HandleInspect',{
						filePath: this.curRow.fileArr.join(','),
						inspectId: this.curRow.id,
						result: ""
					}).then(()=>{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
					})
				})
			},
			upload(row){
				this.curRow = row
				this.$refs.dialogBingliCheckedFile.click();
			},
			changeFile(e){
				var index= e.target.files[0].name.lastIndexOf(".");
				var ext = e.target.files[0].name.substr(index+1);
				var formData = new FormData();
				if(ext==='doc'||ext==='docx'){ // ||ext==='txt'
					formData.append('file', e.target.files[0])
					this.$util.uploadFile(formData).then(data => {
						if (data.timestamp) {
							this.curRow.fileArr.push(data.url)
							this.$http.post('/api/Case/HandleInspect',{
								filePath: this.curRow.fileArr.join(','),
								inspectId: this.curRow.id,
								result: ""
							}).then(()=>{
								this.$message({
									message: '上传成功',
									type: 'success'
								});
							})
						}
					})
				}else if(ext==='png'||ext==='jpg'||ext==='jpeg'){
					formData.append('img', e.target.files[0])
					this.$util.uploadImg_dir(formData,{dir:'businessShop'}).then(data => {
						if (data.timestamp) {
							this.curRow.fileArr.push(data.url)
							this.$http.post('/api/Case/HandleInspect',{
								filePath: this.curRow.fileArr.join(','),
								inspectId: this.curRow.id,
								result: ""
							}).then(()=>{
								this.$message({
									message: '上传成功',
									type: 'success'
								});
							})
						}
					})
				}else{
					this.$message({
						message: '只能上传doc,jpg,png格式的文件',
						type: 'error'
					});
				}
				this.$refs.dialogBingliCheckedFile.value = null
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.label{
			font-size: 14px;font-weight: bold;padding:20px 0 5px;
		}
		::v-deep.el-dialog__body{
			padding-top:10px;
			.itemBox{
				display: flex;padding:20px;
				&:hover{
					background-color: #eee;
				}
				.goodsBox{
					
				}
				.imgBox{
					color:#5E7BFA;padding:8px 0;
					
				}
			}
		}
	}
</style>
